import { createGraphqlApiHandler } from 'api/apollo-client'
import graphqlApi from 'api/graphql-api'
import projectApis from 'api/project'
import appLoadingFeatureActions from 'feature/app-loading.actions'
import { GetProjectJackpotsQueryVariables } from 'graphql/generated/graphql'
import { createApiHandler } from 'helpers/apiHandler'
import { Redux } from 'types/local'
import { createActionsSet } from 'utils/redux'

const types = {
  GET_MY_PROJECT_LIST: createActionsSet.api('my-project.get-project-list'),
  GET_PROJECT_JACKPOTS: createActionsSet.api('my-project.get-project-jackpots'),
}
const getMyProjectList =
  ({
    pageSize,
    page,
    chainId,
    tokenAddress,
    ownerAddress,
    search,
    active,
    feature,
    infoVerify,
    auditVerify,
    emailVerify,
    sortby,
    order,
  }: {
    pageSize: number
    page: number
    chainId: number
    tokenAddress?: string
    ownerAddress?: string
    search?: string
    active?: number
    feature?: number
    infoVerify?: number
    auditVerify?: number
    emailVerify?: number
    sortby?: 'rating' | 'total_vote' | 'total_participant' | 'created'
    order?: 'asc' | 'desc'
  }) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch(appLoadingFeatureActions.start())
    dispatch({
      type: types.GET_MY_PROJECT_LIST.REQUEST,
      payload: {
        pageSize,
        page,
        chainId,
        tokenAddress,
        ownerAddress,
        search,
        active,
        feature,
        infoVerify,
        auditVerify,
        emailVerify,
        sortby,
        order,
      },
    })
    try {
      const handleApi = createApiHandler(dispatch, getState)

      const response = await handleApi(
        projectApis.getProjectList(
          pageSize,
          page,
          chainId,
          tokenAddress,
          ownerAddress,
          search,
          active === 1 ? active : undefined,
          feature === 1 ? feature : undefined,
          infoVerify === 1 ? infoVerify : undefined,
          auditVerify === 1 ? auditVerify : undefined,
          emailVerify === 1 ? emailVerify : undefined,
          sortby,
          order,
        ),
      )
      dispatch({ type: types.GET_MY_PROJECT_LIST.SUCCESS, payload: response })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_MY_PROJECT_LIST.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }

const getProjectJackpots =
  ({ megaGameContract, skip, first, title }: GetProjectJackpotsQueryVariables) =>
  async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_PROJECT_JACKPOTS.REQUEST,
      payload: {
        page: 1,
        pageSize: skip,
      },
    })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getProjectJackpots({ megaGameContract, skip, first, title }))
      dispatch({
        type: types.GET_PROJECT_JACKPOTS.SUCCESS,
        payload: response,
      })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_PROJECT_JACKPOTS.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }

export const myProjectActions = {
  types,
  getMyProjectList,
  getProjectJackpots,
}
